import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, BookOpen } from "lucide-react";
import bookData from "./bookData.json";
import ChapterBody from "./components/reader/ChapterBody";
import TocSidebar from "./components/reader/TocSidebar";
import { EndCta, RightRail } from "./components/reader/ReaderCtas";
import { useScrollToHash, useActiveChapter } from "./components/reader/hooks";

function ReaderHero() {
  return (
    <section className="border-b-2 border-current">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-16 pb-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-display uppercase tracking-widest text-xs hover:text-[hsl(var(--primary))]"
          data-testid="reader-back-link"
        >
          <ArrowLeft size={14} /> Back to NewWaysToday
        </Link>
        <div className="mt-8 flex flex-wrap items-end justify-between gap-6">
          <div>
            <div className="eyebrow mb-3">A Free, Sharable Edition</div>
            <h1 className="font-display uppercase font-bold text-5xl md:text-8xl leading-[0.88] tracking-tight">
              The Book.
            </h1>
            <p className="font-serif-display italic mt-4 text-xl md:text-2xl max-w-2xl opacity-80">
              By Ken Keyes, Jr. · Vision Books · 1981. Not copyrighted. Pass it on.
            </p>
          </div>
          <div className="flex items-center gap-3 text-sm font-display uppercase tracking-widest opacity-80">
            <BookOpen size={16} />
            <span>{bookData.length} chapters</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Reader() {
  const location = useLocation();
  useScrollToHash(location.hash);
  const activeId = useActiveChapter(bookData);

  const scrollToChapter = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.replaceState(null, "", `#${id}`);
    }
  };

  return (
    <main data-testid="reader-page" className="relative z-10">
      <ReaderHero />

      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid gap-12 lg:grid-cols-[260px_1fr] xl:grid-cols-[280px_1fr_220px]">
        <TocSidebar
          chapters={bookData}
          activeId={activeId}
          onNavigate={scrollToChapter}
        />

        <section className="min-w-0">
          {bookData.map((c) => (
            <ChapterBody key={c.id} chapter={c} />
          ))}
          <EndCta />
        </section>

        <RightRail />
      </div>
    </main>
  );
}
